import React from 'react';

/**
 * React component which renders the given content into an iframe.
 */
export class PreviewEmail extends React.Component {
	/**
	 * Called after mounting the component. Triggers initial update of
	 * the iframe
	 */
	componentDidMount() {
		this._updateIframe();
	}

	/**
	 * Called each time the props changes. Triggers an update of the iframe to
	 * pass the new content
	 */
	componentDidUpdate() {
		this._updateIframe();
	}

	/**
	 * Updates the iframes content
	 */
	_updateIframe() {
		const iframe = this.refs.iframe;
		const document = iframe.contentDocument;
		document.body.innerHTML = this.props.content;
	}

	/**
	 * This component renders just and iframe
	 */
	render() {
		return <iframe title='Preview Email' border='0' width='100%' height='700px' ref='iframe' />;
	}
}

export default PreviewEmail;



// WEBPACK FOOTER //
// ./src/containers/dashboard-emails-settings-page/components/preview-email.js